import React, { Component } from 'react';

// import CareerForm from './career';
// import EducationForm from './education';
import MetaForm from './meta';
import RecruitmentForm from './recruitment';
// import IntroForm from '../2_IntroForm'
import * as func from "../../../../../utils/functions";

class DefaultForm extends Component {
  constructor(props) {
    super(props);

    this._isMounted = false;

    this.state = {
      isInit : false,
      isMetaInit: false,
      // edu_data: [],
      // career_data: [],
      meta_data: []
    }
  }

  componentDidMount() {
    this._isMounted = true;

    // func.getData("admin/scholar/" + func.getParams("record_id") + "/career", {}).then((response) => {
    //   if (!this._isMounted) return;
    //
    //   let eduData = (response.record.filter(f => f.career_type === "edu"))
    //   let careerData = (response.record.filter(f => f.career_type === "career"))
    //
    //   this.setState({
    //     isInit: true,
    //     edu_data : eduData,
    //     career_data : careerData
    //   })
    // }).catch((error) => {
    //   console.error('career 데이터 로드 실패:', error)
    // })

    func.getData("admin/scholar/" + func.getParams("record_id") + "/meta", {'sortby': 'date', 'sort': 'desc'}).then((response) => {
      if (!this._isMounted) return;

      this.setState({
        isInit: true,
        isMetaInit: true,
        meta_data: response.record || []
      })
    }).catch((error) => {
      console.error('meta 데이터 로드 실패:', error)
    })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  render() {
    if(!this.state.isInit)
      return '';

    return (
      <>
        <form className="mt-1">
          {/*<div className="row mb-2">*/}
          {/*  <div className="col-md-12 form-group">*/}
          {/*    <EducationForm career_data={this.state.edu_data} />*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="row mb-2">*/}
          {/*  <div className="col-md-12 form-group">*/}
          {/*    <CareerForm career_data={this.state.career_data} />*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="row mb-2">
            <div className="col-md-12 form-group">
              <MetaForm meta_data={this.state.meta_data} isMetaInit={this.state.isMetaInit} key={this.state.meta_data.length} />
            </div>
          </div>
        </form>
        {/*<div className="row mb-2">*/}
        {/*  <div className="col-md-12 form-group">*/}
        {/*    <IntroForm />*/}
        {/*  </div>*/}
        {/*</div>*/}
      </>
    )
  }
}

export default DefaultForm;
